<template>
  <!-- <div> -->

  <v-expand-transition>
    <v-expand-transition v-if="plaintiff">
      <div>
        <v-container class="ma-auto s12" style="min-width: 100%;">
          <!-- <v-card tile> -->
          <v-layout row class="ma-2">
            <v-card-title>
              <v-menu bottom right min-width="200px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn rounded small text v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                    <div>PLAINTIFF MENU</div>
                  </v-btn>
                </template>

                <v-list style="border: 4px solid #2E5473" color="#2E5473">
                  <v-card flat>
                    <v-card-title>PLAINTIFF MENU</v-card-title>
                    <v-card tile>
                      <v-list-item>
                        <v-list-item-title>
                          <template>
                            <div>
                              <app-edit-plaintiff-dialog
                                :matter="matter"
                                :user="user"
                                :plaintiff="plaintiff"
                              ></app-edit-plaintiff-dialog>
                            </div>
                          </template>
                        </v-list-item-title>
                      </v-list-item>
                    </v-card>
                    <v-card tile>
                      <v-list-item class="ma-auto">
                        <v-btn
                          class="ma-auto"
                          large
                          rounded
                          text
                          @click="toggleShowDamages"
                          >damages
                        </v-btn>
                      </v-list-item>
                    </v-card>
                    <v-card tile>
                      <v-list-item class="ma-auto">
                        <v-btn
                          class="ma-auto"
                          large
                          rounded
                          text
                          @click="goToDemand(plaintiff)"
                          >new demand
                        </v-btn>
                      </v-list-item>
                    </v-card>
                    <v-card tile>
                      <v-list-item class="ma-auto">
                        <v-btn
                          class="ma-auto"
                          large
                          rounded
                          text
                          @click="toggleShowPriorDemands"
                          >prior demands
                        </v-btn>
                      </v-list-item>
                    </v-card>
                    <v-card tile>
                      <v-list-item class="ma-auto">
                        <v-btn
                          large
                          class="ma-auto"
                          rounded
                          text
                          @click="toggleShowClientForms"
                          >FORMS
                        </v-btn>
                      </v-list-item>
                    </v-card>
                    <v-card tile>
                      <v-list-item class="ma-auto">
                        <v-btn
                          large
                          class="ma-auto"
                          rounded
                          text
                          @click="openDiscoveryComponent(plaintiff)"
                          >discovery</v-btn
                        >
                      </v-list-item>
                    </v-card>
                    <v-card tile>
                      <v-list-item class="ma-auto">
                        <v-btn large text rounded class="ma-auto">
                          pleadings
                        </v-btn>
                      </v-list-item>
                    </v-card>
                  </v-card>
                </v-list>
              </v-menu>
              <!-- <v-spacer></v-spacer> -->
            </v-card-title>
          </v-layout>
          <!-- </v-card> -->
          <v-layout text-center row class="ma-1">
            <v-expand-x-transition>
              <v-flex class="ma-2" style="width: 25%">
                <!-- <v-card flat> -->
                <v-expand-transition>
                  <v-card
                    flat
                    v-if="!showClientForms && !showDamages && !showPriorDemands"
                    max-height="auto"
                  >
                    <v-card-text class="center-text">
                      <div class="title">PARTY DETAILS</div>
                      <div>
                        <v-icon>mdi-account-circle</v-icon>
                        <div>{{ plaintiff.fullName }}</div>
                      </div>
                      <div>
                        <v-icon>mdi-phone</v-icon>
                        <div>{{ plaintiff.phone }}</div>
                      </div>
                      <div>
                        <v-icon>mdi-email</v-icon>
                        <div>{{ plaintiff.email }}</div>
                      </div>
                      <div>
                        <v-icon>mdi-map-marker</v-icon>
                        <div>
                          {{ plaintiff.addressLine1 || "none" }}
                          {{ plaintiff.cityStateZip }}
                        </div>
                      </div>
                      <div>
                        <v-icon>mdi-date</v-icon>
                        <div>DOB: {{ plaintiff.dateOfBirth }}</div>
                      </div>
                      <div>
                        <div>TYPE: {{ plaintiff.type }}</div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="showDamages"
                    class="ma-2"
                    style="border: 2px solid black;  width: auto;  overflow:auto;"
                    color="#E8E8E8"
                    flat
                  >
                    <v-row>
                      <v-col
                        ><template>
                          <div>
                            <app-add-damage-dialog
                              :matter="matter"
                              :user="user"
                              :plaintiff="plaintiff"
                            ></app-add-damage-dialog>
                          </div>
                        </template>
                      </v-col>
                      <v-col
                        ><v-card-text class="center-text title"
                          >DAMAGES</v-card-text
                        ></v-col
                      >
                      <v-col></v-col>
                    </v-row>

                    <div>
                      <div v-for="(damage, index) in damages" :key="index">
                        <v-card
                          class="ma-2"
                          style="border: 2px solid black;  width: auto;  overflow:auto;"
                          color="#E8E8E8"
                          flat
                        >
                          <v-card-text
                            >DESCRIPTION: {{ damage.description }}</v-card-text
                          >
                          <v-card-text
                            >PROVIDER NAME:
                            {{ damage.providerName }}</v-card-text
                          >
                          <v-card-text
                            >DATES OF SERVICE:
                            {{ damage.datesOfService }}</v-card-text
                          >
                          <v-card-text>
                            VALUE OF LOSS:
                            {{
                              new Intl.NumberFormat("us-US", {
                                style: "currency",
                                currency: "USD"
                              }).format(damage.amount)
                            }}
                          </v-card-text>
                          <v-card-text>
                            Payment: {{damage.payment}}
                           
                          </v-card-text>
                          <v-card-text>
                            Paid by: {{damage.paidBy}}
                          </v-card-text>
                          <v-card-text>
                            Adjustment: {{damage.adjustment}}
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              rounded
                              small
                              color="red"
                              outlined
                              :disabled="user.email !== matter.creatorID"
                              @click="deleteDamage(damage)"
                              >DELETE</v-btn
                            >
                            <v-btn
                              rounded
                              small
                              color="yellow"
                              outlined
                              @click="editDamage(index)"
                              >EDIT</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </div>
                    </div>
                  </v-card>
                  <v-card v-if="showClientForms" flat filled>
                    <v-row>
                      <v-col></v-col>
                      <v-col
                        ><v-card-text class="center-text title"
                          >CLIENT FORMS</v-card-text
                        ></v-col
                      >
                      <v-col>
                        <v-btn
                          text
                          small
                          rounded
                          color="red"
                          @click="toggleShowClientForms"
                          v-if="showClientForms"
                          >hide</v-btn
                        ></v-col
                      >
                    </v-row>
                    <v-card-text class="center-text title"
                      ><template>
                        <div>
                          <send-client-form-dialog
                            :matter="matter"
                            :user="user"
                            :plaintiff="plaintiff"
                          ></send-client-form-dialog>
                        </div> </template
                    ></v-card-text>
                    <v-layout
                      row
                      class="ml-1 mr-3"
                      v-if="clientResponseList.length > 0"
                    >
                      <v-flex>
                        <div
                          v-for="clientResponse in clientResponseList"
                          :key="clientResponse.id"
                        >
                          <div v-if="plaintiff.formList">
                            <v-expand-transition>
                              <v-card
                                class="ma-2"
                                flat
                                outlined
                                style="border-radius: 26px; border: 1px solid #18CAE6"
                              >
                                <v-container>
                                  <v-card-text>
                                    <div
                                      class="body-1 text-justify  font-weight-heavy"
                                    >
                                      BY:
                                      <span
                                        class="body-1 text-justify font-weight-light"
                                        >{{
                                          clientResponse.partyName.toUpperCase() ||
                                            ""
                                        }}</span
                                      >
                                    </div>
                                    <div
                                      class="body-1 text-justify  font-weight-heavy"
                                    >
                                      FORM NAME:
                                      <span
                                        class="body-1 text-justify font-weight-light text-wrap"
                                        >{{ clientResponse.name }}</span
                                      >
                                    </div>
                                    <div
                                      class="body-1 text-justify  font-weight-heavy text-wrap"
                                    >
                                      RESPONSE ID:
                                      <span
                                        class="body-1 text-justify font-weight-light text-wrap"
                                        >{{ clientResponse.id }}</span
                                      >
                                    </div>
                                    <div
                                      class="body-1 text-justify  font-weight-heavy text-wrap"
                                    >
                                      RESPONSE DATE:
                                      <span
                                        class="body-1 text-justify font-weight-light text-wrap"
                                        v-if="clientResponse.responseDate"
                                        >{{
                                          clientResponse.responseDate.toUpperCase()
                                        }}</span
                                      >
                                    </div>
                                  </v-card-text>
                                  <v-card-actions class="ma-0 pa-0">
                                    <v-layout row>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        small
                                        text
                                        rounded
                                        color="red"
                                        class="ma-auto"
                                        @click="deleteForm(clientResponse)"
                                        >delete</v-btn
                                      >
                                      <v-spacer></v-spacer>
                                      <template>
                                        <div>
                                          <app-selected-doc-form
                                            :matter="matter"
                                            :user="user"
                                            :responses="clientResponse"
                                          ></app-selected-doc-form>
                                        </div>
                                      </template>
                                      <v-spacer></v-spacer>
                                      <template>
                                        <div>
                                          <app-create-plaintiff-doc
                                            :matter="matter"
                                            :user="user"
                                            :responses="clientResponse"
                                            :plaintiff="plaintiff"
                                          ></app-create-plaintiff-doc>
                                        </div>
                                      </template>
                                      <v-spacer></v-spacer>
                                    </v-layout>
                                  </v-card-actions>
                                </v-container>
                              </v-card>
                            </v-expand-transition>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card>

                  <!-- DEMAND  -->

                  <v-card v-if="showPriorDemands" color="black">
                    <v-card-text class="center-text title"
                      >PRIOR DEMANDS</v-card-text
                    >
                    <v-layout row class="ml-1 mr-3">
                      <v-flex>
                        <div v-for="(demand, i) in demands" :key="i">
                          <div>
                            <v-expand-transition>
                              <v-card
                                style="
                                    background-color: black;
                                    border-radius: 26px;
                                    border: 1px solid #18CAE6;
                                    max-width: 650px;
                                  "
                                class="ma-auto font-weight-light"
                              >
                                <v-container>
                                  <v-card-text>
                                    {{ demand.name }}
                                  </v-card-text>
                                </v-container>
                                <v-card-actions>
                                  <v-btn
                                    outlined
                                    rounded
                                    color="red"
                                    class="ma-auto"
                                    @click="deletePriorDemand(i)"
                                    >delete</v-btn
                                  >
                                  <v-btn
                                    outlined
                                    rounded
                                    color="yellow"
                                    class="ma-auto"
                                    @click="goToPriorDemand(i)"
                                    >view</v-btn
                                  >
                                </v-card-actions>
                              </v-card>
                            </v-expand-transition>
                          </div>
                        </div>
                      </v-flex>
                      <v-flex>
                        <v-card color="black" outlined>
                          <v-btn
                            outlined
                            small
                            rounded
                            color="red"
                            @click="toggleShowPriorDemands"
                            v-if="showPriorDemands"
                            >hide</v-btn
                          >
                          <v-layout row class="ma-1">
                            <v-btn
                              large
                              text
                              outlined
                              rounded
                              class="ma-3"
                              color="green"
                              style="background-color: black"
                              @click="goToDemand(plaintiff)"
                              >NEW DEMAND</v-btn
                            >
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-expand-transition>
                <!-- </v-card> -->
              </v-flex>
            </v-expand-x-transition>
          </v-layout>
        </v-container>

        <!-- <div>
          <v-spacer></v-spacer>

          <v-spacer></v-spacer>
         

          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

         

          <v-spacer></v-spacer>
        
          <div>
            <v-expand-transition
              v-for="(damage, index) in damages"
              :key="index"
            >
             
              <v-card class="ma-2">
                <v-card-text>DESCRIPTION: {{ damage.description }}</v-card-text>
                <v-card-text
                  >PROVIDER NAME: {{ damage.providerName }}</v-card-text
                >
                <v-card-text
                  >DATES OF SERVICE: {{ damage.datesOfService }}</v-card-text
                >
                <v-card-text>
                  VALUE OF LOSS:
                  {{
                    new Intl.NumberFormat("us-US", {
                      style: "currency",
                      currency: "USD"
                    }).format(damage.amount)
                  }}
                </v-card-text>
              </v-card>
            </v-expand-transition>
          </div>
        </div> -->
      </div>
    </v-expand-transition>
  </v-expand-transition>

  <!-- </div> -->
</template>

<script>
/**
 * this compontent shoes some plaintiff details and allows you to:
 * 1. add damages to the plaintiff
 * 2. edit the plaintiff object
 * 3. send the client a form to fill out (see SendCLientForm component)
 * 4. vie the responses already sent to the client (if any have been responded to)
 * //todo: show the forms that have been sent to the client even if there are no responses yet...
 *
 * when a client is sent a form from the app (SendClientForm component)
 * the client gets a link, visits the link and begins filling out the form
 * once the form is saved (when the client user clicks "next" on the form)
 * the user sees an obect within the ViewPlaintiff component.
 * this component sets a listener on the client collection named after the Plaintiff being viewed here
 * within the matter document in the database
 * when changes are made to the client's formList collection
 * it is reflected here and a card is made for each object in the client's formList collection
 * two components are also created for each item in client's formList
 * 1. SelectedDocForm which shows teh user the form and the responses of the client in real time
 * 2. CreatePlaintiffDoc which allows the user to createa a document specific to the plaintiff selected.
 *
 *
 * //todo: needs better ui
 */

import * as firebase from "firebase";
export default {
  props: ["matter", "user", "plaintiff"],
  data() {
    return {
      clientResponseList: [],
      showClientForms: false,
      showDamages: false,
      showPriorDemands: false,
      demands: []
    };
  },
  watch: {
    clientResponseList(val) {
      console.log("clientResponseList", val);
    }
  },
  computed: {
    menuTitle() {
      if (this.showDamages) {
        return `DAMAGES`;
      } else if (this.showClientForms) {
        return `CLIENT FORMS`;
      }
      return `MENU`;
    },
    viewingPlaintiff() {
      // if (
      //   this.$store.viewingParty == null ||
      //   this.$store.viewingParty == undefined
      // ) {
      //   return "select a party";
      // } else {
      //   return this.$store.viewingParty;
      // }
      return this.$store.getters.plaintiff;
    },
    damages() {
      const specificDamages = [];
      if (this.matter.damages) {
        this.matter.damages.forEach(damage => {
          // if (damage.party === this.viewingPlaintiff.partySlug) {
          if (damage.party === this.plaintiff.partySlug) {
            specificDamages.push(damage);
          }
        });
        // this.matter.damages.find(
        //   damage => damage.party === this.viewingPlaintiff.partySlug
        // );
        // return specificDamages;
      }
      // else {
      //   return null;
      // }
      return specificDamages;
    }
  },
  methods: {
    deletePriorDemand(i) {
      alert(
        "Are you sure you want to permanently delete this demand? This operation cannot be undone."
      );
      let name = this.demands[i].name;

      let demandRef = firebase
        .storage()
        .ref()
        .child(name);
      console.log(name);

      demandRef
        .delete()
        .then(() => {
          console.log("demand deleted from storage");
          let demand = this.demands[i];
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .collection("clients")
            .doc(this.plaintiff.partySlug)
            .update({
              demands: firebase.firestore.FieldValue.arrayRemove(demand)
            })
            .then(() => {
              console.log("demand removed from database");
            })
            .catch(e => console.log(e));
        })
        .catch(e => console.log(e));
    },
    deleteDamage(damage) {
      firebase
        .firestore()
        // .collection("firms")
        // .doc(firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          damages: firebase.firestore.FieldValue.arrayRemove(damage)
        })
        .then(() => {
          console.log("delete success");
        })
        .catch(e => console.log(e));
    },
    goToDemand(plaintiff) {
      let windowName = `${plaintiff.fullName}`;
      let windowLink = `${window.location.origin}/matters/${this.matter.matterSlug}/${plaintiff.partySlug}/demand`;
      window.open(windowLink, windowName);
    },
    goToPriorDemand(i) {
      let windowName = this.demands[i].name;
      let windowLink = this.demands[i].url;
      window.open(windowLink, windowName);
    },
    openDiscoveryComponent(plaintiff) {
      let windowName = `${plaintiff.fullName}`;
      let windowLink = `${window.location.origin}/matters/${this.matter.matterSlug}/${plaintiff.partySlug}/discovery`;
      window.open(windowLink, windowName);
    },

    toggleShowDamages() {
      this.showDamages = !this.showDamages;
      this.showClientForms = false;
      this.showPriorDemands = false;
    },
    toggleShowPriorDemands() {
      this.showPriorDemands = !this.showPriorDemands;
      this.showDamages = false;
      this.showClientForms = false;
    },
    toggleShowClientForms() {
      this.showClientForms = !this.showClientForms;
      this.showDamages = false;
    },
    logPlaintiff() {
      console.log(
        "viewingPlaintiff being passed to edit plaintiff dialog",
        this.viewingPlaintiff
      );
    },
    sendClientForm() {
      let formRoute = `/firm/${this.user.firmSlug}/matter/${this.matter.matterSlug}/client/${this.viewingPlaintiff.partySlug}`;
      console.log("from viewPlaintiff");
      console.log("matter", this.matter);
      console.log("user", this.user);
      console.log("plaintiff", this.viewingPlaintiff);
      console.log("formRoute", formRoute);
      //opens a dialog that allows the user to select which questions they want answered
      //creates a client user (cloud function) in auth
      //creates a client form collection in database
      //send an email with link that takes client to the formRoute
      //when client visits link they are asked to input first and last name phone
      //signs client in and pulls the form
      //form is filled and signature is taken
      //responses are saved and signature is saved
      //user is notified
      //user can view and edit responses
      //user can create a document with the data from the form responses
    },
    deleteForm(resp) {
      alert(
        "are you sure you want to delete this set of form responses? you will not be able to recorver the data once deleted"
      );
      console.log(resp);
      //find the form in the plaintiff's formlist

      let p = this.matter.plaintiffs.find(
        pl => pl.fullName === this.plaintiff.fullName
      );
      console.log("p=", p);
      let pi = this.matter.plaintiffs.indexOf(p);
      console.log("index of plaintiff", pi);
      let f = p.formList.find(form => form.id === resp.id);
      let fi = p.formList.indexOf(f);
      console.log("index of Form in plaintiff formlist", fi);
      console.log("deleting this form: ", f.id);

      p.formList.splice(fi, 1);

      console.log("deleting this plaintiff", p);
      this.matter.plaintiffs.splice(pi, 1, p);
      console.log("formList", p.formList);
      console.log("plaintiff list", this.matter.plaintiffs);

      console.log("new matter with deleted form ", this.matter);

      //update plaintiff in matter
      firebase
        .firestore()
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          plaintiffs: this.matter.plaintiffs
        })
        .then(() => {
          firebase
            .firestore()
            .collection("matters")
            .doc(this.matter.matterSlug)
            .collection("clients")
            .doc(this.plaintiff.partySlug)
            .collection("formList")
            .doc(f.id)
            .delete()
            .then(() => {
              console.log(
                "deleted this form from client formlist collection ",
                f.id
              );
            });
          console.log("updated plaintiff array");
        })
        .catch(e => console.error(e));
      //find the form in the client collection's form list
      //delete the form from the list.
    },
    clearPlaintiff() {
      this.$store.dispatch("clearPlaintiff");
    },
    addDamage() {
      console.log("viewingPlaintiff:", this.viewingPlaintiff);
    },
    editPlaintiff() {
      // let plaintiff = this.$store.getters.plaintiff;
      // let firmSlug = this.user.firmSlug;
      let matterSlug = this.matter.matterSlug;
      let oldPlaintiff = this.viewingPlaintiff;
      let editedPlaintiff = {
        ...this.viewingPlaintiff,
        additionalInfo: "additionalInfo"
      };

      firebase
        .firestore()
        // .collection("firms")
        // .doc(firmSlug)
        .collection("matters")
        .doc(matterSlug)
        .update({
          plaintiffs: firebase.firestore.FieldValue.arrayRemove(oldPlaintiff)
        })
        .then(() => {
          console.log("delete success");
          firebase
            .firestore()
            // .collection("firms")
            // .doc(firmSlug)
            .collection("matters")
            .doc(matterSlug)
            .update({
              plaintiffs: firebase.firestore.FieldValue.arrayUnion(
                editedPlaintiff
              )
            })
            .then(() => {
              console.log("update success");
            })
            .catch(e => console.log(e));
        })
        .catch(e => console.log(e));
      // .set({ plaintiffs: [{ plaintiff }] }, { merge: true })
    }
  },
  created() {
    console.log("hello from created at viewplaintiff", this.plaintiff);

    let clientRef = firebase
      .firestore()
      .collection("matters")
      .doc(this.matter.matterSlug)
      .collection("clients")
      .doc(this.plaintiff.partySlug);

    let formRef = firebase
      .firestore()
      // .collection("firms")
      // .doc(this.user.firmSlug)
      .collection("matters")
      .doc(this.matter.matterSlug)
      .collection("clients")
      .doc(this.plaintiff.partySlug)
      .collection("formList");

    let oldFormRef = firebase
      .firestore()
      .collection("matters")
      .doc(this.matter.matterSlug)
      .collection("clients");
    // .doc(this.plaintiff.partySlug);

    if (this.plaintiff.formList) {
      console.log(
        "hello from created at ViewPlaintiff",
        this.plaintiff.formList
      );
      formRef.onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            const addedForm = change.doc.data();
            const existingForm = this.clientResponseList.find(
              form => form.id === addedForm.id
            );
            if (existingForm !== null && existingForm !== undefined) {
              console.log("client already in list", addedForm);
              return;
            } else {
              this.clientResponseList.push(addedForm);
              console.log("added form", addedForm);
            }
          } else if (change.type === "modified") {
            const modifiedForm = change.doc.data();
            const existingForm = this.clientResponseList.find(
              form => form.id === modifiedForm.id
            );
            if (existingForm !== null && existingForm !== undefined) {
              console.log(
                "client already in list: replacing it now",
                existingForm
              );
              //find the index of existing client
              let index = this.clientResponseList.indexOf(existingForm);
              this.clientResponseList.splice(index, 1, modifiedForm);
            } else {
              this.clientResponseList.push(modifiedForm);
              console.log("added form", modifiedForm);
            }
          } else if (change.type === "removed") {
            const removedForm = change.doc.data();
            console.log("form being removed", removedForm);
            const existingForm = this.clientResponseList.find(
              form => form.id === form.id
            );
            const index = this.clientResponseList.indexOf(existingForm);
            this.clientResponseList.splice(index, 1);
          }
        });
      });
    } else if (!this.plaintiff.formList) {
      oldFormRef.onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            const addedOldForm = change.doc.data();
            const existingOldForm = this.clientResponseList.find(
              form => form.clientSlug === addedOldForm.clientSlug
            );
            if (existingOldForm !== null && existingOldForm !== undefined) {
              console.log("client already in list", addedOldForm);
              return;
            } else {
              this.clientResponseList.push(addedOldForm);
              console.log("added form", addedOldForm);
            }
          } else if (change.type === "modified") {
            const modifiedOldForm = change.doc.data();
            const existingOldForm = this.clientResponseList.find(
              form => form.clientSlug === modifiedOldForm.clientSlug
            );
            if (existingOldForm !== null && existingOldForm !== undefined) {
              console.log(
                "client already in list: replacing it now",
                existingOldForm
              );
              //find the index of existing client
              let index = this.clientResponseList.indexOf(existingOldForm);
              this.clientResponseList.splice(index, 1, modifiedOldForm);
            } else {
              this.clientResponseList.push(modifiedOldForm);
              console.log("added form", modifiedOldForm);
            }
          } else if (change.type === "removed") {
            const removedOldForm = change.doc.data();
            console.log("form being removed", removedOldForm);
            const existingOldForm = this.clientResponseList.find(
              form => form.clientSlug === form.clientSlug
            );
            const index = this.clientResponseList.indexOf(existingOldForm);
            this.clientResponseList.splice(index, 1);
          }
        });
        // let data = res.data();
        // console.log(data);
        // this.clientResponseList.push(data);
      });
    }
    clientRef.onSnapshot(doc => {
      let data = doc.data();
      console.log("client", data);
      if (data.demands && data.demands.length >= 0) {
        this.demands = data.demands;
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
